import { Sheet, SheetContent } from '@/components/shadcn/sheet'
import { ReactNode, Suspense, useState } from 'react'
import { DataTableV2DataRow, DataTableV2SheetContentAction } from '../types'
import { SheetComponentRenderer } from '../../SheetComponentRenderer'
import { getSheetContentLayout } from '../../sheetContentLayout'
import { FormData } from '../../DataFormComponent/types'
import { JsonFormPropertyV2 } from '../../FormComponent/types'

type SheetContentActionTrigger = ReactNode | ((onOpen: () => void) => ReactNode)

export function SheetContentAction({
  action,
  trigger,
  formData,
  isDisabled,
  onSubmitOverride,
}: {
  action: DataTableV2SheetContentAction
  formData?: DataTableV2DataRow
  trigger: SheetContentActionTrigger
  isDisabled?: boolean
  onSubmitOverride?: (groupId: string, data: FormData, formProperties: JsonFormPropertyV2[]) => void
}) {
  const [isOpen, setIsOpen] = useState(false)
  const { contentId, contentType } = action.content
  const { side, className } = getSheetContentLayout(contentType)
  const triggerContent = typeof trigger === 'function' ? trigger(() => setIsOpen(true)) : trigger
  const onOpenChange = (open: boolean) => {
    if (!isDisabled) {
      setIsOpen(open)
    }
  }
  return (
    <Sheet open={isOpen} onOpenChange={onOpenChange}>
      {triggerContent}
      <SheetContent side={side} className={className}>
        <Suspense fallback={<div>Loading...</div>}>
          <SheetComponentRenderer
            contentType={contentType}
            contentId={contentId}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            actionId={action.id}
            formData={formData}
            onSubmitOverride={onSubmitOverride}
          />
        </Suspense>
      </SheetContent>
    </Sheet>
  )
}
